export default function Font_Size() {
  return (
    <div className="p-4">
      <h1>Font Size</h1>
    </div>
  );
}
